import React from 'react';
import ArchitectureCard from './ArchitectureCard';

function CardList({ cards, onDrill }) {
  return (
    <div className="space-y-2">
      {cards.map((card) => (
        <ArchitectureCard key={card.id} card={card} onDrill={onDrill} />
      ))}
    </div>
  );
}

export default function ArchitectureTab({ config, onDrill }) {
  if (!config) return null;
  const { title, subtitle, cards, sections } = config;

  return (
    <div className="space-y-6">
      <div>
        <h3 className="text-base font-semibold text-gray-800 mb-1">{title}</h3>
        {subtitle && <p className="text-xs text-gray-500">{subtitle}</p>}
      </div>

      {sections ? (
        sections.map((section) => (
          <div key={section.id} className="space-y-2">
            <div className="text-[11px] font-semibold uppercase tracking-wide text-gray-400">
              {section.title}
            </div>
            <CardList cards={section.cards} onDrill={onDrill} />
          </div>
        ))
      ) : (
        <CardList cards={cards || []} onDrill={onDrill} />
      )}
    </div>
  );
}
